import Vue from 'vue'
import moment from 'moment'

Vue.filter('currency', function (value) {
  if (!value) { return 0 }
  return value.toLocaleString().replace(/,/g, " ")
})

Vue.filter('currencyTwoDecimals', function (value) {
  if (!value) { return 0 }
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).replace(/,/g, " ")
})

Vue.filter('date_DMMMYYYY', function (dateString) {
  if (!dateString) { return null }
  return moment(dateString).format('D MMM YYYY')
})

Vue.filter('time', function (dateString) {
  if (!dateString) { return null }
  return moment(dateString).format('D MMM YY, HH:mm:ss')
})
